// extracted by mini-css-extract-plugin
export default {"form":"FormHeader_form__aRItC","form__button-icon":"FormHeader_form__button-icon__0dXxJ"};